import { Component, Input, SimpleChanges, OnChanges } from '@angular/core';

import { PatentService } from 'app/fs/res/patent/service/patent/patent.service';
import { Patent } from 'app/fs/res/patent/model/patent/patent';

@Component( {
    selector: 'res-patent-view-family',
    templateUrl: './patent-view-family.component.html',
} )
export class PatentViewFamilyComponent implements OnChanges {
    @Input() patent: Patent; // ngModel
    public patentFamily: Array<Patent> = [];

    constructor( private patentService: PatentService ) {}

    /* Component ngOnChanges() */
    ngOnChanges( changes: SimpleChanges ) {
        if ( changes.patent.previousValue && !this.patentFamily.length ) {
            // get data for section patent family depending on patent type
            // (if is priority patent or patent with priority claim)
            let patentId = this.patent.priorityPatent == null ? this.patent.id : this.patent.priorityPatent.id;
            this.patentFamily = [];

            if ( this.patent.priorityPatent != null && this.patent.priorityPatent.id > 0) {
                // add priorityPatent itself as well
                this.patentFamily.push( this.patent.priorityPatent );
            }

            // load child patents
            if ( patentId ) {
                this.patentService.getPatentFamily( patentId ).subscribe( ( patents: Patent[] )=> {
                    patents.forEach( (p: Patent) => {
                        if (p.id > 0 &&  p.id !== this.patent.id ) {
                            this.patentFamily.push( p );
                        }
                    } );
                } );
            }
        }
    }
}
